/* eslint-disable camelcase */
import PropTypes from 'prop-types';

import { propTypesTextHtml } from '../../../constants/Proptypes';

const propTypesSliceGridWithMainLines = {
  grid_main_lines_slice_id: PropTypes.string,
  first_headline: PropTypes.shape(propTypesTextHtml).isRequired,
  second_headline: PropTypes.shape(propTypesTextHtml).isRequired,
};

const propTypesItemsGridWithMainLines = {
  first_title: PropTypes.string.isRequired,
  second_title: PropTypes.string.isRequired,
  first_content: PropTypes.shape(propTypesTextHtml).isRequired,
  second_content: PropTypes.shape(propTypesTextHtml).isRequired,
};

export const propTypesDataGridWithMainLines = {
  id: PropTypes.string,
  slice_type: PropTypes.string,
  slice_label: PropTypes.string,
  primary: PropTypes.shape(propTypesSliceGridWithMainLines),
  items: PropTypes.arrayOf(PropTypes.shape(propTypesItemsGridWithMainLines)),
};
